import en from './languages/en';
import { ReactCreateTranslatorOptions, type FlatKeys, type FlattenDict } from 'schummar-translate/react';

export type AppDict = typeof en;
export type FlatAppDict = FlattenDict<AppDict>;
export type TranslationKeys = FlatKeys<AppDict>;
export type AppProvidedArgs = keyof typeof commonTranslatorConfig.provideArgs;

const warningsSeen = new Set<string>();

export const commonTranslatorConfig = {
    sourceLocale: 'en',
    sourceDictionary: en,
    fallbackLocale: ['de', 'en'],
    ignoreMissingArgs: true,

    warn: (locale, id) => {
        const key = `${locale}:${id}`;
        if (warningsSeen.has(key)) return;
        warningsSeen.add(key);
        console.warn('Missing translation:', locale, key);
    },

    dateTimeFormatOptions: {
        dateStyle: 'medium',
        timeStyle: 'medium',
    },

    provideArgs: {
        cartBrand: 'Whiz-Cart',
        cartBrandShort: 'Whiz-Cart',
        storeBrand: 'Supermarket',
        loyaltyCard: 'Loyalty Card',
    },
} satisfies ReactCreateTranslatorOptions<any, any>;
